import type { StateCreator } from 'zustand';

import { fetchScratchGameMenuCMS } from '@/api/cms';
import { EScratchTicketTheme } from '@/modules/promotions';
import type {
  CommonStoreType,
  ScratchGameState,
} from '@/store/commonStore/types';

export const useScratchGameSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  ScratchGameState
> = (set) => ({
  scratchGameMenuData: null,
  pendingScratchGameMenuData: false,
  scratchGameTheme: EScratchTicketTheme.BASIC,
  isFinished: {
    [EScratchTicketTheme.BASIC]: false,
    [EScratchTicketTheme.PREMIUM]: false,
  },
  bonus: {
    [EScratchTicketTheme.BASIC]: null,
    [EScratchTicketTheme.PREMIUM]: null,
  },
  fetchScratchGameMenuData: async (locale: string) => {
    try {
      set({ pendingScratchGameMenuData: true });
      const { data } = await fetchScratchGameMenuCMS(locale);

      set({ scratchGameMenuData: data || null });
    } catch (error) {
      console.log(error);
    } finally {
      set({ pendingScratchGameMenuData: false });
    }
  },
  setScratchGameTheme: (theme: EScratchTicketTheme) => {
    set({ scratchGameTheme: theme });
  },
  setIsFinished: (theme, value) => {
    set((state) => ({
      isFinished: {
        ...state.isFinished,
        [theme]: value,
      },
    }));
  },

  setBonus: (theme, value) => {
    set((state) => ({
      bonus: {
        ...state.bonus,
        [theme]: value,
      },
    }));
  },
});
